import { EKeyCode } from '@/enums/e_key_code';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { WATCHER_SHORTCUT__base } from '../../shortcuts/_watchers/WATCHER_SHORTCUT__base';

export function WATCHER__shortcut_grid2d_gallery_close() {
  const dispatch = use_dispatch();

  return (
    <WATCHER_SHORTCUT__base
      key_codes={[EKeyCode.Escape]}
      on_shortcut_pressed={() => {
        dispatch(LOCAL__ui_set_boolean({ key: 'global__grid2d_show_as_gallery', value: false }));
        return true;
      }}
    />
  );
}
